import React, { useState, useEffect } from "react";
import { Overlay, FormH1, CloseButton, History, Message, InputWrapper, InputCard, ExpandingTextarea, SendButton, SpinningIcon, AIWrapper, ClearButton } from "./AgenticModalElements";
import SendPrompt from '../BedrockLibrary/PromptGeneration';
import { v4 as uuidv4 } from 'uuid';

export const AgenticOverlay = ({ isOpen, onClose }) => {
    const [messages, setMessages] = useState(() => {
        const saved = localStorage.getItem("chatMessages");
        return saved ? JSON.parse(saved) : [];
    });

    const [input, setInput] = useState("");
    const [loadingBoolean, setLoadingBoolean] = useState(false);
    const [sessionId] = useState(() => uuidv4());

    // Save messages
    useEffect(() => {
        localStorage.setItem("chatMessages", JSON.stringify(messages));
    }, [messages]);


    if (!isOpen) return null;
    const handleSend = async () => {
        if (!input.trim()) return;
        const userMessage = { role: "user", content: input };
        setMessages((prev) => [...prev, userMessage]);
        setInput("");

        // Stubbed API call — replace with your actual Bedrock/OpenAI endpoint
        const response = await agentCall(input);
        // Fix line breaks inside "response" field
        const restructured = restructurePayload(response)
        console.log(restructured)
        const assistantMessage = { role: "assistant", content: JSON.stringify(restructured) };
        setMessages((prev) => [...prev, assistantMessage]);
    };

    const restructurePayload = (payload) => {
        // Try parsing the string
        try {
            return JSON.parse(payload);
        } catch (err) {
            // If it fails, sanitize the response field and try again
            try {
                const safe = payload.replace(/"response":\s*"([\s\S]*?)"/, (match, p1) => {
                    const escaped = p1.replace(/\n/g, "\\n").replace(/"/g, '\\"');
                    return `"response": "${escaped}"`;
                });
                return JSON.parse(safe);
            } catch (err2) {
                // Final fallback
                return {
                    response: payload,
                    slate: [],
                    timeframe: "",
                    players: [],
                    teams: []
                };
            }


        };
    }

    const agentCall = async (prompt) => {
        setLoadingBoolean(true);
        try {
            const res = await SendPrompt(sessionId, prompt);
            console.log(res);
            setLoadingBoolean(false);
            return res;
        } catch (error) {
            console.error('Error calling Bedrock:', error);
            setLoadingBoolean(false);
            throw error;
        }
    };
    return (
        <Overlay isOpen={isOpen}>
            <AIWrapper>
                <FormH1 className="chat-header">Ca$h Crew AI</FormH1>
                <History>
                    {messages.map((msg, idx) => (
                        <Message key={idx} role={msg.role}>
                            {msg.role === 'user' ? msg.content : JSON.parse(msg.content).response}
                        </Message>
                    ))}
                    {loadingBoolean && <SpinningIcon />}
                </History>
                <InputWrapper>
                    <InputCard>
                        {messages.length > 0 && (
                            <ClearButton onClick={() => setMessages([])} disabled={loadingBoolean}>
                                Clear Chat
                            </ClearButton>
                        )}

                        <ExpandingTextarea
                            type="text"
                            placeholder="🧠 How Can I Help You Get That W?"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && handleSend()}
                            disabled={loadingBoolean}
                        />

                        <SendButton onClick={handleSend} disabled={loadingBoolean}>
                            {loadingBoolean ? <SpinningIcon /> : 'Send'}
                        </SendButton>
                    </InputCard>
                </InputWrapper>
            </AIWrapper>
        </Overlay>
    );
};

export default AgenticOverlay;
